// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --azulthink: #1E90FF;
    --white-color: #FFFFFF;
    --black-color: #000000;
    --claro-cinza-color: #898A8C;
    --claro2-cinza--color: #F7F7F7;
    --claro-verde-musgo-color : #AEC422;
    --claro-rosa-color: #C38E8E;
    --claro-castanho-color: #C3AE8E;
    --claro-azul-color: #8EADC3;
    --claro2-azul-color: #A3B4BF;
    --medio-alaranjado-color: #C95412;
    --medio-azul-color: #02767D;
    --medio2-azul-color: #3E4B99;
    --medio-azul-marin-color: #152166;
    --medio2-azul-marin-color: #1C2D8E;
    --medio-verde-color: #007e11;
    --vermelho-tipoPag: #c90e40;
    --escuro-vermelho-vinho-color: #B60000;
    --escuro2-azul-color: #101A54;
    --escuro-azul-color: #040133;
} 
`, "",{"version":3,"sources":["webpack://./src/assets/css/colors.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAC9B,mCAAmC;IACnC,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;IAC3B,sCAAsC;IACtC,6BAA6B;IAC7B,4BAA4B;AAChC","sourcesContent":[":root{\r\n    --azulthink: #1E90FF;\r\n    --white-color: #FFFFFF;\r\n    --black-color: #000000;\r\n    --claro-cinza-color: #898A8C;\r\n    --claro2-cinza--color: #F7F7F7;\r\n    --claro-verde-musgo-color : #AEC422;\r\n    --claro-rosa-color: #C38E8E;\r\n    --claro-castanho-color: #C3AE8E;\r\n    --claro-azul-color: #8EADC3;\r\n    --claro2-azul-color: #A3B4BF;\r\n    --medio-alaranjado-color: #C95412;\r\n    --medio-azul-color: #02767D;\r\n    --medio2-azul-color: #3E4B99;\r\n    --medio-azul-marin-color: #152166;\r\n    --medio2-azul-marin-color: #1C2D8E;\r\n    --medio-verde-color: #007e11;\r\n    --vermelho-tipoPag: #c90e40;\r\n    --escuro-vermelho-vinho-color: #B60000;\r\n    --escuro2-azul-color: #101A54;\r\n    --escuro-azul-color: #040133;\r\n} \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
